export const ID49 = () => {
    return (
        <div>
            <div className="content" readonly="">


                <h1>Битрикс24 помогает бизнесу работать</h1>
                <p>Вместо десятков сервисов и приложений — единая платформа для организации работы всей компании.</p>

                <h2>Онлайн-офис для совместной работы</h2>
                <p>Мгновенно выходите на связь с любым сотрудником, согласовывайте документы и счета, общайтесь с
                    коллегами.</p>

                <div>
                    <h3>Видеозвонки до 100 человек</h3>
                    <p>Бесплатно общайтесь по видео с коллегами, клиентами, подрядчиками. Начать совещание можно прямо
                        из чата или встречи в календаре!</p>

                    <h3>Мессенджер</h3>
                    <p>Создавайте сколько угодно чатов и каналов, чтобы обсуждать идеи и делиться файлами.</p>

                    <h3>Учет рабочего времени и отчеты</h3>
                    <p>Сотрудник может начать, приостановить и завершить рабочий день за один клик в Битрикс24.
                        Устанавливайте график и фиксируйте отработанные часы.</p>
                </div>

                <div>
                    <h2>Современная CRM, в которой есть всё</h2>
                    <p>Подключайте почту, телефонию, соцсети, рекламу, сквозную аналитику, склады за пару кликов.</p>

                    <div>
                        <div className="pb-3">
                            <div className="pb-2"><b>Мобильная CRM</b></div>
                            Работайте с лидами, общайтесь с клиентами во всех каналах, заполняйте документы, выставляйте
                            счета и принимайте оплату — прямо со смартфона.
                        </div>
                        <div className="pb-3">
                            <div className="pb-2"><b>Клиентская база</b></div>
                            Собирайте заявки со всех каналов: формы на сайте, онлайн-чаты, телефонные звонки и соцсети.
                            Контакты, вся переписка и записи разговоров сохранятся в
                            CRM.
                        </div>
                        <div className="pb-3">
                            <div className="pb-2"><b>Автоматизация продаж</b></div>
                            Десятки роботов для автоматизации продаж и маркетинга сэкономят ваше время и деньги.
                        </div>
                    </div>
                </div>

                <h2>Задачи и проекты</h2>
                <p>Выбирайте удобный режим работы с проектами, назначайте ответственных, используйте чек-листы и шаблоны
                    регулярных задач.</p>

                <div className="bxst-features-section-content">
                    <div className="pb-3">
                        <div className="pb-2"><b>Управление проектами в разных режимах</b></div>
                        Используйте списки, чек-листы, диаграмму Ганта, календарь для контроля сроков и исполнителей.
                        Или организуйте работу по правилам Скрам, используя канбан
                        и другие готовые инструменты.
                    </div>

                    <div className="pb-3">
                        <div className="pb-2"><b>Роли и права доступа</b></div>
                        Распределите роли в задаче: ответственный, постановщик и наблюдатели. Вы можете настроить права
                        на постановку задач, перенос крайнего срока и
                        делегирование.
                    </div>

                    <div className="pb-3">
                        <div className="pb-2"><b>Шаблоны задач и роботы</b></div>
                        Создавайте шаблоны для регулярных задач, настраивайте автоматическую отправку писем, смену
                        ответственного и статуса задачи.
                    </div>
                </div>

                <div className="bxst-block-title bxst-title-sm pb-1 pt-5">Ваш личный AI-помощник CoPilot</div>

                <p>Поиск идей, работа с текстом, расшифровка звонка от клиента, заполнение CRM, планирование — все это
                    станет проще с CoPilot.</p>

                <div className="bxst-features-section-content">
                    <div className="pb-3">
                        <div className="pb-2"><b>CoPilot там, где вы привыкли работать </b></div>
                        <p>Вы удивитесь, как гармонично CoPilot встроен в ваши ежедневные рабочие сценарии.</p>
                        <p>
                            Открывайте привычные вам инструменты, одним кликом вызывайте AI и мгновенно получайте
                            результат. Вам даже не нужно учиться общаться с ИИ — мы
                            написали работающие промпты за вас.
                        </p>
                    </div>

                    <div className="pb-3">
                        <div className="pb-2"><b>Открытый CoPilot</b></div>
                        Выбирайте ту модель AI, которая лучше решает ваши задачи: GigaChat, YandexGPT, IT Solutions или
                        приложения из Маркета.
                    </div>
                </div>

                <h2>Сайты и лендинги — в простом конструкторе</h2>
                <p>Создайте свой сайт, используя готовые блоки и шаблоны. Подключите онлайн-чат и собирайте заявки от
                    клиентов!</p>

                <div className="bxst-features-section-content">
                    <div className="pb-3">
                        <div className="pb-2"><b>Сайт внутри в CRM</b></div>
                        Сайт не нужно специально интегрировать с CRM, он создается внутри CRM :) Все контакты клиентов
                        сохраняются и попадают в работу менеджерам.
                    </div>
                    <div className="pb-3">
                        <div className="pb-2"><b>Готовы к продвижению</b></div>
                        Ваш сайт уже готов к SEO-продвижению: страницы загружаются быстро и соответствуют требованиям
                        поисковиков.
                    </div>
                    <div className="pb-3">
                        <div className="pb-2"><b>Полная адаптивность</b></div>
                        Блоки сайта сами адаптируются для мобильных устройств. Клиентам из соцсетей будет удобно
                        пользоваться сайтом и оставлять заявки.
                    </div>
                </div>

                <h2>Интернет-магазин за 120 секунд</h2>
                <p>Получайте заказы из соцсетей и обрабатывайте их в CRM.</p>

                <div className="bxst-features-section-content">
                    <div className="pb-3">
                        <div className="pb-2"><b>Быстрое создание</b></div>
                        Нажмите кнопку «Создать», добавьте товары в каталог, разместите ссылку на магазин в соцсетях и
                        принимайте заказы. Все контакты автоматически попадают в
                        CRM.
                    </div>
                    <div className="pb-3">
                        <div className="pb-2"><b>Удобный каталог товаров</b></div>
                        Добавить товар в каталог легко — введите описание, цену, загрузите фото и готово! Поддерживает
                        SKU. А складской учет поможет контролировать остатки на
                        складе.
                    </div>
                    <div className="pb-3">
                        <div className="pb-2"><b>Заказы из всех каналов</b></div>
                        Опубликуйте ссылку на интернет-магазин в соцсетях, отправьте ссылку клиенту в WhatsApp или SMS!
                        Для быстрого оформления заказа нужно всего лишь оставить
                        имя и номер телефона.
                    </div>
                </div>
            </div>
        </div>
    )
}